import React from "react";

const PromoList = () => {
  return <div>PromoList</div>;
};

export default PromoList;
